import { message, Space } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import InputDate from "../../../components/input-date";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../components/action-bar";
import ActionButton from "../../../components/action-button";
import MiniTable from "../../../components/mini-table";
import { Alerta } from "../../../constants";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import useLoading from "../../../hooks/useLoading";
import { fetchLicencas, isEditableSelector, licencasAlertaNivelSelector, licencasAlertasSelector, licencasSearchSelector, licencasSelector, licencasFilterDateSelector, fetchVerificarLimite } from "../../../store/empresa";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import { openPopup } from "../../../util/window";
import Alertas from "../_Alertas";
import styles from "../_styles.less";
import EmpresaLicencasTable from "./_table";
import useModulo from "../../../hooks/useModulo";
import moment from "moment";
import SelectEmpresaUnidade from "../../../components/select-empresa-unidade";
import EmpresaDrawer from "../../../components/workflow-menu/_EmpresaDrawer";
import TarefasDrawer from "./_tarefasDrawer";
import { useLocation } from "react-router";
import ModuloTarefaModal from "../../../components/tarefa-modal/_WorkflowTarefaModal";

export default function EmpresaLicencasDetailPage() {
  const miniTableRef = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const nivel = useSelector(licencasAlertaNivelSelector);
  const isEditable = useSelector(isEditableSelector);
  const licencas = useSelector(licencasSelector);
  const search = useSelector(licencasSearchSelector);
  const filterDate = useSelector(licencasFilterDateSelector);
  const alertas = useSelector(licencasAlertasSelector);
  const loading = useLoading(fetchLicencas.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();

  const empresaId = match.params.empresaId;
  const { moduloBasePath } = useModulo();
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;
  const handleDate = (date) => {
    const filterDate = date ? moment(date).format("YYYY-MM-DD") : null;
    dispatch(fetchLicencas({ empresaId, filterDate }));
  };

  const handleSearch = (search) => {
    dispatch(fetchLicencas({ empresaId, search }));
  };

  const handleUnidade = (unidade) => {
    dispatch(fetchLicencas({ empresaId, unidade }));
  };

  const handleCreate = () => {
    unwrapAxiosPromise(dispatch(fetchVerificarLimite()))
    .then(() => {
     history.replace(`${moduloBasePath}/empresas/${empresaId}/licencas/create`);
    })
  };

  const handleRemove = () => {
    setLoadingRemove(true);
    unwrapAxiosPromise(
      axios.delete(`/empresas/${empresaId}/licencas`, {
        params: { ids: selectedIds },
      })
    )
      .then(() => {
        message.success(t("Registro(s) removido(s) com sucesso"));
        setSelectedIds([]);
        dispatch(fetchLicencas({ empresaId }));
      })
      .finally(() => setLoadingRemove(false));
  };

  const handleDetail = (licenca) => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/licencas/${licenca.id}`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/licencas/`, `logs_/empresas/${empresaId}/licencas/`);
  };

  const actions = [];
  if (isEditable) {
    actions.push(<ActionButton.Create disabled={isNA} onClick={handleCreate} />);
    actions.push(<ActionButton.Remove disabled={selectedIds.length === 0 || isNA} onClick={handleRemove} loading={loadingRemove} />);
  }
  actions.push(<ActionButton.Logs noTitle onClick={handleLogs} />);
  actions.push(<MiniTable.DownloadButton disabled={loading || licencas.length === 0} miniTableRef={miniTableRef} />);
  const title = () => (
    <ActionBar leftActions={[<SelectEmpresaUnidade disabled={false} empresaId={empresaId} style={{ minWidth: 200 }} onChange={handleUnidade} />]} search={search} onSearch={handleSearch}>
      {actions}
    </ActionBar>
  );
  return (
    <>
      <Space direction="vertical" className={styles["space-2"]}>
        <EmpresaLicencasTable dataSource={licencas} loading={loading} miniTableRef={miniTableRef} onClick={handleDetail} onSelectedIdsChange={setSelectedIds} selectedIds={selectedIds} title={title} />
        <Alertas alertas={alertas} />
      </Space>
    </>
  );
}

EmpresaLicencasDetailPage.propTypes = {
  licencas: PropTypes.array,
  onCreate: PropTypes.func,
  onRemove: PropTypes.func,
};
